import React from "react";
import DashboardView from "../DashboardView";

export default function Home() {
  return (
    <DashboardView>
      <div>
        <h2>Homes</h2>
      </div>
    </DashboardView>
  );
}
